@if (shouldShowTrainingProgress()) {
  <glxy-empty-state class="training-in-progress">
    <glxy-empty-state-hero>
      <ai-knowledge-loading-spinner />
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ getTrainingProgressTitle() | translate }}
      @if (shouldShowProgressCount()) {
        {{ getProgressDisplay() }}
      }
    </glxy-empty-state-title>
    @if (showDone()) {
      <p>{{ 'EDIT_KNOWLEDGE.TRAINING.TRAINING_DONE_TOOLTIP' | translate }}</p>
    } @else {
      <p>{{ 'EDIT_KNOWLEDGE.TRAINING.TRAINING_IN_PROGRESS_CLARIFICATION' | translate }}</p>
    }
  </glxy-empty-state>
}
